import getCfuReducer from './getCfu';
import cfuInspectReducer from './inspectCfu';

const cfuRootReducer = {
  inspectCfu: cfuInspectReducer,
  cfu: getCfuReducer,
};
export { cfuRootReducer };
